module.exports = __webpack_public_path__ + "static/media/WhatsApp.89a81819.png";